/* =========================================================
   Adapter fiche produit COL (Shopify).
   - Rend le col officiel (data-map asset) via SNColPoster
   - Import GPX/TCX/FIT : rend LA sortie du client (SNColMap.build + Overpass)
   - Palette + perso + taille/cadre/prix + add-to-cart
   ========================================================= */
(function () {
  const SP = window.SPORTSNDECO_PRODUCT;
  if (!SP) return;

  const SIZE_LABEL  = { '30x40':'30 × 40 cm', '50x70':'50 × 70 cm', '70x100':'70 × 100 cm' };
  const FRAME_LABEL = { none:'Sans cadre', black:'Cadre noir', natural:'Cadre bois naturel' };
  const SIZES  = [{id:'30x40',label:'30 × 40 cm'},{id:'50x70',label:'50 × 70 cm'},{id:'70x100',label:'70 × 100 cm'}];
  const SN_DIG = window.SPORTSNDECO_DIGITAL || null;
  if (SN_DIG && SN_DIG.variantId) SIZES.push({ id: 'digital', label: 'Fichier numérique HD' });
  function snDigitalUi() {
    var dig = state.size === 'digital';
    var fw = document.getElementById('frameOptions');
    if (fw) {
      var note = document.getElementById('snDigitalFrameNote');
      if (dig) {
        fw.style.display = 'none';
        if (!note) {
          note = document.createElement('p');
          note.id = 'snDigitalFrameNote';
          note.style.cssText = "font:400 13px/1.5 'Inter',sans-serif;color:#5b6b82;margin:4px 0 0;";
          note.textContent = "Fichier num\u00e9rique : pas de cadre \u2014 vous recevez le PDF haute d\u00e9finition par e-mail, imprimable jusqu'en 70\u00d7100 cm.";
          fw.parentNode.insertBefore(note, fw.nextSibling);
        } else note.hidden = false;
      } else { fw.style.display = ''; if (note) note.hidden = true; }
    }
    var dl = document.querySelector('[data-sn-delivery] [data-sn-delivery-main], [data-sn-delivery] .sn-delivery__main');
    if (dl) {
      if (dig) { if (!dl.dataset.print) dl.dataset.print = dl.innerHTML; dl.innerHTML = 'Fichier HD envoy\u00e9 par e-mail <strong>apr\u00e8s paiement</strong>'; }
      else if (dl.dataset.print) { dl.innerHTML = dl.dataset.print; delete dl.dataset.print; }
    }
    ['digital','replique','carte'].forEach(function(k){ var up=document.querySelector('.sn-upsell[data-key="'+k+'"]'); if(up) up.style.display = dig ? 'none' : ''; });
  }
  const FRAMES = [{id:'none',label:'Sans cadre'},{id:'black',label:'Cadre noir'},{id:'natural',label:'Cadre bois naturel'}];
  const OVERPASS = ['https://overpass-api.de/api/interpreter','https://overpass.kumi.systems/api/interpreter'];

  const state = { size:'50x70', frame:'none', palette:'blanc', colMap:null, rideMap:null, ride:null };

  const $ = id => document.getElementById(id);
  const esc = s => String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const money = c => (c/100).toFixed(2).replace('.',',') + ' €';
  function variant(s,f){ if (s === 'digital' && SN_DIG) return { id: SN_DIG.variantId, price: SN_DIG.priceCents, options: ['Fichier num\u00e9rique HD'], available: true, digital: true }; return SP.variants.find(v => v.options.includes(SIZE_LABEL[s]) && v.options.includes(FRAME_LABEL[f])); }
  function upsellsCents(){ return (typeof window.snUpsellsTotalCents==='function') ? window.snUpsellsTotalCents() : 0; }
  function refreshPrice(){
    const v = variant(state.size, state.frame);
    const base = v ? v.price : 0, total = base + upsellsCents();
    const pe=$('productPrice'); if(pe) pe.textContent = v ? money(base) : '—';
    ['cartPrice','snStickyPrice'].forEach(id => { const e=$(id); if(e) e.textContent = v ? money(total) : '—'; }); snDigitalUi(); }
  window.snRefreshPrice = refreshPrice; // appelé par le snippet upsells

  /* ---- options d'affichage (cases à cocher) ---- */
  function opts(){
    return {
      palette: state.palette,
      perso: $('colPerso') ? $('colPerso').value : '',
      title: ($('colTitle') && $('colTitle').value.trim()) ? $('colTitle').value.trim() : undefined,
      chrono: ($('colShowChrono') && $('colShowChrono').checked && $('colChrono')) ? $('colChrono').value : '',
      duo: ($('colDuo') && $('colDuo').checked) ? {
        n1: $('colD1Name') ? $('colD1Name').value : '',   t1: $('colD1Chrono') ? $('colD1Chrono').value : '',
        n2: $('colD2Name') ? $('colD2Name').value : '',   t2: $('colD2Chrono') ? $('colD2Chrono').value : '',
      } : undefined,
      showStats: $('colShowStats') ? $('colShowStats').checked : true,
      showCoord: $('colShowCoord') ? $('colShowCoord').checked : true,
      showProfile: $('colShowProfile') ? $('colShowProfile').checked : false,
    };
  }

  /* ---- rendu ---- */
  function activeMap(){ return state.rideMap || state.colMap; }
  function draw(){
    const md = activeMap();
    if (!md || typeof SNColPoster === 'undefined') return;
    const svg = SNColPoster.render(md, opts());
    $('poster').innerHTML = svg;
    const pal = SNColPoster.PALETTES[state.palette];
    const pf = $('posterFrame');
    if (pf){ if (pal) pf.style.background = pal.pageBg; pf.dataset.frame = state.frame; }
    // mockups : même SVG, cadre différent via CSS sur le wrapper
    document.querySelectorAll('.sn-frame-thumb .poster').forEach(el => { el.innerHTML = svg; });
  }
  function syncFrameThumbs(){ document.querySelectorAll('.sn-frame-thumb').forEach(t => t.classList.toggle('active', t.dataset.frame===state.frame)); }

  /* ---- palettes ---- */
  function renderPalettes(){
    const wrap = $('colPalettes'); if (!wrap || typeof SNColPoster==='undefined') return;
    wrap.innerHTML = '';
    Object.entries(SNColPoster.PALETTES).forEach(([id,p]) => {
      const b = document.createElement('button');
      b.type='button'; b.className='sn-col-pal'+(id===state.palette?' active':''); b.title=p.label;
      b.innerHTML = `<span style="background:${p.pageBg}"></span><em style="background:${p.track}"></em>`;
      b.addEventListener('click', ()=>{ state.palette=id; wrap.querySelectorAll('.sn-col-pal').forEach(x=>x.classList.toggle('active',x===b)); draw(); });
      wrap.appendChild(b);
    });
  }

  /* ---- taille / cadre ---- */
  function renderSizes(){
    const w=$('sizeOptions'); if(!w) return;
    w.innerHTML = SIZES.map(s=>{const v=variant(s.id,state.frame);
      return `<button class="size-opt ${s.id===state.size?'active':''}" data-size="${s.id}" type="button"><span class="size-label">${s.label}</span><span class="size-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.size-opt').forEach(b=>b.addEventListener('click',()=>{state.size=b.dataset.size;renderSizes();renderFrames();refreshPrice();}));
  }
  function renderFrames(){
    const w=$('frameOptions'); if(!w) return;
    w.innerHTML = FRAMES.map(f=>{const v=variant(state.size,f.id);
      return `<button class="frame-opt ${f.id===state.frame?'active':''}" data-frame="${f.id}" type="button"><span class="frame-swatch frame-swatch-${f.id}"></span><span class="frame-label">${f.label}</span><span class="frame-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.frame-opt').forEach(b=>b.addEventListener('click',()=>{state.frame=b.dataset.frame;renderSizes();renderFrames();refreshPrice();syncFrameThumbs();draw();}));
  }
  function bindMockups(){
    document.querySelectorAll('.sn-frame-thumb').forEach(t=>t.addEventListener('click',()=>{
      state.frame=t.dataset.frame; renderSizes(); renderFrames(); refreshPrice(); syncFrameThumbs(); draw();
    }));
    syncFrameThumbs();
  }

  /* ---- IMPORT GPX/TCX/FIT ---- */
  async function fetchRoads(bbox){
    const { S, W, N, E } = bbox;
    const q = `[out:json][timeout:30];(way["highway"](${S},${W},${N},${E}););out geom;`;
    for (const ep of OVERPASS){
      try {
        const r = await fetch(ep, { method:'POST', body:'data='+encodeURIComponent(q) });
        const txt = await r.text();
        if (txt.trim().startsWith('{')) { const els=JSON.parse(txt).elements; if(els&&els.length) return els; }
      } catch(e){ /* next */ }
    }
    return [];
  }

  function maxEle(samples){ let m=-Infinity; for(const s of samples) if(typeof s.ele==='number'&&s.ele>m)m=s.ele; return isFinite(m)?Math.round(m):null; }
  function fmtDate(d){ try{ return new Date(d).toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'}).toUpperCase(); }catch(e){ return ''; } }

  async function handleFile(file){
    const ext = (file.name.split('.').pop()||'').toLowerCase();
    let activity;
    try {
      if (ext==='gpx' && typeof parseGPX==='function')      activity = parseGPX(await file.text());
      else if (ext==='tcx' && typeof parseTCX==='function') activity = parseTCX(await file.text());
      else if (ext==='fit' && typeof parseFIT==='function') activity = await parseFIT(await file.arrayBuffer());
      else { alert('Format non supporté. Utilisez GPX, TCX ou FIT.'); return; }
    } catch(e){ alert('Erreur de lecture : '+e.message); return; }
    if (!activity.name) activity.name = file.name.replace(/\.[^.]+$/,'');
    await processActivity(activity, '✓ '+file.name);
  }

  /* rend une activité (fichier GPX/TCX/FIT OU sortie Strava) sur l'affiche */
  async function processActivity(activity, dzLabel){
    const coords = (activity.samples||[]).filter(s=>typeof s.lat==='number'&&typeof s.lon==='number').map(s=>[s.lon,s.lat]);
    if (coords.length<2){ alert("Cette activité ne contient pas de tracé GPS."); return; }
    const stats = (typeof computeStats==='function') ? computeStats(activity) : {};
    const km = stats.distanceM ? +(stats.distanceM/1000).toFixed(1) : 0;
    const dplus = stats.elevGainM ? Math.round(stats.elevGainM) : 0;
    const pct = (stats.distanceM && stats.elevGainM) ? +((stats.elevGainM/stats.distanceM)*100).toFixed(1) : 0;
    const alt = maxEle(activity.samples) || 0;
    const last = coords[coords.length-1];
    const meta = {
      name: activity.name || 'Ma sortie',
      side:'', eyebrow:'Mon ascension',
      region: stats.startTime ? fmtDate(stats.startTime) : '',
      country:'', km, dplus, pct, alt, lat:last[1], lon:last[0],
    };

    // feedback dropzone + reset
    const dz = $('colDropzone');
    if (dz){ dz.querySelector('.dz-title').textContent = dzLabel || ('✓ '+meta.name); dz.querySelector('.dz-sub').textContent = km+' km · '+dplus+' m D+ · carte en cours…'; }
    const reset = $('colResetRide'); if (reset) reset.hidden = false;
    // pré-remplit le titre avec le nom de la sortie (si vide ou encore = titre produit par défaut)
    if ($('colTitle') && (!$('colTitle').value.trim() || $('colTitle').value.trim() === (SP.title||'').trim())) $('colTitle').value = meta.name.slice(0,28);

    // 1) rendu immédiat : tracé sur carte vide
    state.ride = { coords, meta };
    state.rideMap = SNColMap.build(coords, [], meta);
    draw();

    // 2) fetch des routes réelles de la zone, puis re-render
    try {
      const roads = await fetchRoads(SNColMap.bboxOf(coords));
      state.rideMap = SNColMap.build(coords, roads, meta);
      draw();
      if (dz) dz.querySelector('.dz-sub').textContent = km+' km · '+dplus+' m D+ · '+roads.length+' routes';
    } catch(e){
      if (dz) dz.querySelector('.dz-sub').textContent = km+' km · '+dplus+' m D+ (fond simplifié)';
    }
  }

  /* ---- CONNEXION STRAVA (réutilise le worker déjà déployé + le rendu ci-dessus) ---- */
  const SVA = (typeof CONFIG !== 'undefined' && CONFIG.strava) ? CONFIG.strava : null;
  const Strava = {
    KEY:'sd_strava', state:{ tokens:null, athlete:null },
    ready(){ return !!(SVA && SVA.clientId && SVA.workerUrl && SVA.clientId.indexOf('__')!==0); },
    connected(){ return !!(this.state.tokens && this.state.athlete); },
    load(){ try{ const s=JSON.parse(localStorage.getItem(this.KEY)); if(s&&s.tokens&&s.athlete) this.state=s; }catch(e){} },
    save(){ try{ localStorage.setItem(this.KEY, JSON.stringify(this.state)); }catch(e){} },
    connect(){
      const redirect = location.origin + location.pathname + location.search;
      const p = new URLSearchParams({ client_id:SVA.clientId, redirect_uri:redirect, response_type:'code', approval_prompt:'auto', scope:SVA.scopes||'read,activity:read_all' });
      location.href = 'https://www.strava.com/oauth/authorize?' + p;
    },
    disconnect(){ this.state={ tokens:null, athlete:null }; try{ localStorage.removeItem(this.KEY); }catch(e){} renderStrava(); },
    async handleCallback(){
      const u=new URL(location.href), code=u.searchParams.get('code'), err=u.searchParams.get('error');
      if (err){ cleanUrl(); return; }
      if (!code) return;
      const acts=$('colStravaActs'); if(acts) acts.innerHTML='<p class="sn-strava-msg">Connexion à Strava…</p>';
      try{
        const r=await fetch(SVA.workerUrl+'/exchange',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ code }) });
        if(!r.ok) throw new Error('exchange '+r.status);
        const d=await r.json();
        this.state.tokens={ access_token:d.access_token, refresh_token:d.refresh_token, expires_at:d.expires_at };
        this.state.athlete=d.athlete; this.save(); cleanUrl(); renderStrava();
      }catch(e){ cleanUrl(); if(acts) acts.innerHTML='<p class="sn-strava-msg">Connexion Strava échouée : '+esc(e.message)+'</p>'; }
    },
    async token(){
      if(!this.state.tokens) throw new Error('Non connecté');
      const now=Math.floor(Date.now()/1000);
      if(this.state.tokens.expires_at-now>300) return this.state.tokens.access_token;
      const r=await fetch(SVA.workerUrl+'/refresh',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ refresh_token:this.state.tokens.refresh_token }) });
      if(!r.ok){ this.disconnect(); throw new Error('Session Strava expirée, reconnectez-vous'); }
      const d=await r.json(); this.state.tokens={ access_token:d.access_token, refresh_token:d.refresh_token, expires_at:d.expires_at }; this.save();
      return this.state.tokens.access_token;
    },
    async activities(){ const t=await this.token(); const r=await fetch('https://www.strava.com/api/v3/athlete/activities?per_page=30',{ headers:{Authorization:'Bearer '+t} }); if(!r.ok) throw new Error('activités '+r.status); return r.json(); },
    async streams(id){ const t=await this.token(); const r=await fetch('https://www.strava.com/api/v3/activities/'+id+'/streams?keys=latlng,altitude,time&key_by_type=true',{ headers:{Authorization:'Bearer '+t} }); if(!r.ok) throw new Error('streams '+r.status); return r.json(); },
  };
  function cleanUrl(){ const u=new URL(location.href); ['code','scope','state','error'].forEach(k=>u.searchParams.delete(k)); history.replaceState({}, document.title, u.pathname+u.search+u.hash); }
  const STRAVA_LOGO='<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path fill="currentColor" d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.599h4.172L10.463 0l-7 13.828h4.169"/></svg>';
  function renderStrava(){
    const wrap=$('colStravaBlock'); if(!wrap || !Strava.ready()) return;
    if(!Strava.connected()){
      wrap.innerHTML = '<button type="button" class="sn-strava-btn" id="colStravaConnect">'+STRAVA_LOGO+'<span>Se connecter à Strava</span></button>';
      $('colStravaConnect').addEventListener('click',()=>Strava.connect());
      const acts=$('colStravaActs'); if(acts) acts.innerHTML='';
      return;
    }
    const a=Strava.state.athlete;
    wrap.innerHTML = '<div class="sn-strava-on">'+(a.profile?'<img class="sn-strava-av" src="'+esc(a.profile)+'" alt="">':'')
      + '<div class="sn-strava-who"><span>Connecté à Strava</span><strong>'+esc(((a.firstname||'')+' '+(a.lastname||'')).trim())+'</strong></div>'
      + '<button type="button" class="link-btn" id="colStravaOff">Déconnecter</button></div>';
    $('colStravaOff').addEventListener('click',()=>Strava.disconnect());
    loadActs();
  }
  async function loadActs(){
    const acts=$('colStravaActs'); if(!acts || !Strava.connected()) return;
    acts.innerHTML='<p class="sn-strava-msg">Chargement de vos activités…</p>';
    try{
      const list=(await Strava.activities()).filter(a=>a.start_latlng && a.start_latlng.length);
      if(!list.length){ acts.innerHTML='<p class="sn-strava-msg">Aucune activité avec tracé GPS sur votre compte.</p>'; return; }
      acts.innerHTML = list.map(a=>'<button type="button" class="sn-strava-act" data-id="'+a.id+'"><span class="sa-name">'+esc(a.name)+'</span><span class="sa-meta">'+(a.distance/1000).toFixed(1).replace('.',',')+' km · '+(a.total_elevation_gain?Math.round(a.total_elevation_gain)+' m D+':'—')+'</span></button>').join('');
      acts.querySelectorAll('.sn-strava-act').forEach(b=>b.addEventListener('click',()=>{ const s=list.find(x=>String(x.id)===b.dataset.id); if(s) pickActivity(s, b); }));
    }catch(e){ acts.innerHTML='<p class="sn-strava-msg">'+esc(e.message)+'</p>'; }
  }
  async function pickActivity(summary, btn){
    const acts=$('colStravaActs');
    if(acts){ acts.querySelectorAll('.sn-strava-act').forEach(b=>b.classList.remove('active')); if(btn) btn.classList.add('active','loading'); }
    try{
      const st=await Strava.streams(summary.id);
      const ll=st.latlng&&st.latlng.data, al=st.altitude&&st.altitude.data, tm=st.time&&st.time.data;
      if(!ll||!ll.length){ alert("Cette activité n'a pas de tracé GPS."); return; }
      const start=summary.start_date?new Date(summary.start_date):null;
      const samples=ll.map((p,i)=>({ lat:p[0], lon:p[1], ele:(al&&Number.isFinite(al[i]))?al[i]:null, time:(start&&tm)?new Date(start.getTime()+(tm[i]||0)*1000):null }));
      await processActivity({ name:summary.name, samples }, '✓ '+summary.name);
    }catch(e){ alert('Erreur Strava : '+e.message); }
    finally{ if(btn) btn.classList.remove('loading'); }
  }
  function bindStrava(){
    if(!Strava.ready()) return;                 // config absente → on laisse juste l'import fichier
    const wrap=$('colStravaWrap'); if(wrap) wrap.hidden=false;
    Strava.load(); renderStrava(); Strava.handleCallback();
  }

  function resetRide(){
    state.ride = null; state.rideMap = null;
    const dz=$('colDropzone'); if(dz){ dz.querySelector('.dz-title').textContent='Déposez votre sortie'; dz.querySelector('.dz-sub').textContent='GPX · TCX · FIT'; }
    const reset=$('colResetRide'); if(reset) reset.hidden=true;
    draw();
  }

  function bindImport(){
    const dz=$('colDropzone'), input=$('colFileInput'), browse=$('colBrowseBtn'), reset=$('colResetRide');
    if (browse&&input) browse.addEventListener('click',()=>input.click());
    if (input) input.addEventListener('change',e=>{ if(e.target.files[0]) handleFile(e.target.files[0]); });
    if (dz){
      ['dragenter','dragover'].forEach(ev=>dz.addEventListener(ev,e=>{e.preventDefault();dz.classList.add('dragover');}));
      ['dragleave','drop'].forEach(ev=>dz.addEventListener(ev,e=>{e.preventDefault();dz.classList.remove('dragover');}));
      dz.addEventListener('drop',e=>{ if(e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });
    }
    if (reset) reset.addEventListener('click',resetRide);
  }

  /* ---- add to cart ---- */
  function bindCart(){
    const btn=$('addToCartBtn'); if(!btn) return;
    const buy=$('buyNowBtn'), sticky=$('snStickyAddBtn');
    if (buy) buy.addEventListener('click',e=>{e.preventDefault();window.__snBuyNow=true;btn.click();});
    if (sticky) sticky.addEventListener('click',e=>{e.preventDefault();btn.click();});
    btn.addEventListener('click', async ()=>{
      const v=variant(state.size,state.frame); if(!v){alert('Variante introuvable');return;}
      const o=opts();
      const perso=(o.perso||'').trim(), titleOv=(o.title||'').trim(), chrono=(o.chrono||'').trim();
      const props={ 'Palette': SNColPoster.PALETTES[state.palette].label };
      if (perso)   props['Texte']=perso;
      if (titleOv) props['Titre']=titleOv;
      if (chrono)  props['Chrono']=chrono;
      const duo = o.duo && [o.duo.n1,o.duo.t1,o.duo.n2,o.duo.t2].some(v=>String(v||'').trim()) ? o.duo : null;
      if (duo) {
        const lbl=[[duo.n1,duo.t1].filter(Boolean).join(' '),[duo.n2,duo.t2].filter(Boolean).join(' ')].filter(Boolean).join(' & ');
        if (lbl) props['Duo']=lbl;
      }
      if (!o.showStats) props['Statistiques']='Masquées';
      if (!o.showCoord) props['Coordonnées']='Masquées';
      if (o.showProfile) props['Profil altimétrique']='Affiché';
      if (state.ride) props['Tracé']='Sortie perso importée ('+state.ride.meta.km+' km)';
      const payload={ col:SP.presetId, palette:state.palette, perso, title:titleOv, chrono,
        showStats:o.showStats, showCoord:o.showCoord, showProfile:o.showProfile, size:state.size, frame:state.frame,
        mapUrl:SP.mapDataUrl };  // → re-render serveur (worker Gelato) pour les presets
      if (duo) payload.duo = duo;  // mode couple : 2 colonnes prénom+chrono
      if (state.ride) {
        // coords downsamplées (~120 pts) pour rester sous la limite de propriété Shopify
        const c = state.ride.coords, step = Math.max(1, Math.ceil(c.length/120));
        const ds = c.filter((_,i)=>i%step===0);
        if (ds[ds.length-1] !== c[c.length-1]) ds.push(c[c.length-1]);
        payload.ride = { name:state.ride.meta.name, km:state.ride.meta.km, dplus:state.ride.meta.dplus,
          alt:state.ride.meta.alt, region:state.ride.meta.region, coords:ds.map(p=>[+p[0].toFixed(5),+p[1].toFixed(5)]) };
        // Tracé importé : le worker ne peut pas reconstruire la carte (Overpass)
        // → on upload l'aperçu EXACT rasterisé (voie B hybride).
        if (window.snPrintUpload) {
          const up = await window.snPrintUpload.fromSvg(SNColPoster.render(activeMap(), o),
            { fontCssUrls: [window.snPrintUpload.FONTS.sora], size: state.size });
          if (up) { props['_print_url']=up.url; props['_print_bg']=SNColPoster.PALETTES[state.palette].pageBg; }
          else props['_print_error'] = String(window.snPrintUpload.lastError() || 'inconnu');
        }
      }
      props['_perso']=JSON.stringify(payload);
      if (state.size === 'digital') { props['Format'] = 'Fichier num\u00e9rique HD (PDF par e-mail)'; var h1 = document.querySelector('h1.product-title, h1'); if (h1) props['Mod\u00e8le'] = h1.textContent.trim(); }
      const items=[{ id:v.id, quantity:1, properties:props }];
      if (typeof window.snCollectUpsells==='function') { try { items.push(...window.snCollectUpsells()); } catch(e){} }
      const sp=btn.querySelector('span'); const old=sp?sp.textContent:''; btn.disabled=true; if(sp)sp.textContent='Ajout…';
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!r.ok){const e=await r.json().catch(()=>({}));throw new Error(e.description||e.message||('Erreur '+r.status));}
        if(window.__snBuyNow){window.__snBuyNow=false;window.location.href='/checkout';return;}
        document.dispatchEvent(new CustomEvent('sn:cart-added'));
      }catch(e){alert("Erreur d'ajout au panier : "+e.message);}
      finally{setTimeout(()=>{if(sp)sp.textContent=old;btn.disabled=false;},600);}
    });
  }

  function bindSticky(){
    const sticky=$('snStickyCta'), cart=$('addToCartBtn'); if(!sticky||!cart) return;
    const mob=()=>window.matchMedia('(max-width:900px)').matches;
    function up(){ if(!mob()){sticky.classList.remove('is-visible');return;}
      const r=cart.getBoundingClientRect(); const near=(innerHeight+scrollY)>(document.body.scrollHeight-200);
      sticky.classList.toggle('is-visible', r.bottom<60 && !near);
    }
    addEventListener('scroll',up,{passive:true}); addEventListener('resize',up); up();
  }

  document.addEventListener('DOMContentLoaded', async () => {
    renderSizes(); renderFrames(); refreshPrice(); renderPalettes(); bindCart(); bindSticky(); bindImport(); bindMockups(); bindStrava();
    ['colPerso','colTitle','colChrono'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('input',draw); });
    ['colShowStats','colShowCoord','colShowProfile'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('change',draw); });
    const sc=$('colShowChrono'); if(sc) sc.addEventListener('change',()=>{ const f=$('colChronoField'); if(f) f.hidden=!sc.checked; draw(); });
    ['colD1Name','colD1Chrono','colD2Name','colD2Chrono'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('input',draw); });
    const dt=$('colDuo'); if(dt) dt.addEventListener('change',()=>{ const df=$('colDuoFields'); if(df) df.hidden=!dt.checked; const sb=$('colSoloPerso'); if(sb) sb.hidden=dt.checked; draw(); });
    try {
      const r=await fetch(SP.mapDataUrl); state.colMap=await r.json();
      const tog=$('colProfileToggle'); if(tog && state.colMap && state.colMap.profile) tog.hidden=false; // profil dispo → propose la case
      draw();
    }
    catch(e){ console.error('[col] data-map non chargé :', e); }
  });
})();
